import React, { useEffect, useRef } from 'react'
import { TempusDominus, Namespace } from '@eonasdan/tempus-dominus';
import "@eonasdan/tempus-dominus/dist/css/tempus-dominus.css";
import icons from './icons'
import { parse, format } from 'date-fns'


function DatePicker({ id, value, onChange, dateFormat, isInvalid, ...props }) {
  const ref = useRef(null)

  useEffect(() => {
    const target = document.getElementById(id)
    if(!target) return
    if(target.hasAttribute("has-date-picker")) return

    const elem = new TempusDominus(target, {
      display: {
        icons,
        buttons: {
          today: false,
          clear: false,
          close: false
        },
        components: {
          decades: false,
          year: true,
          month: true,
          date: true,
          hours: false,
          minutes: false,
          seconds: false
        },
      },
      localization: {
        format: dateFormat
      },
    })

    const subscriptions = elem.subscribe(
      [Namespace.events.show, Namespace.events.hide],
      [pickerDidShow, pickerDidHide]
    )


    return () => {
      subscriptions.forEach(subscription => subscription.unsubscribe())
      if(target.hasAttribute("has-date-picker")) {
        target.removeAttribute("has-date-picker")
      }
    }
  }, [id])

  function handleChange(e) {
    const { value } = e.target
    onChange(value)
  }



  function pickerDidShow(e) {
  }

  function pickerDidHide(e) {
    const { date } = e
    if(date) {
      const formatted = format(date, dateFormat)
      onChange(formatted)
    }
    else {
      onChange('')
    }
  }

  return (
    <input
      ref={ref}
      id={id}
      value={value}
      onChange={handleChange}
      className={`form-control ${isInvalid ? 'is-invalid' : ''} ${props.className || ''}`}
      type="text"
      {...props}
    />
  )
}

export default DatePicker
